import { useApi } from '@/api';
import { KpiCard, KpiSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex } from '@blockanalitica/ui';

export default function LitePSMKpis({ daysAgo }) {
  const [data, error] = useApi({
    url: '/groups/stablecoins/ilks/LITE-PSM-USDC-A/parameters/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Flex flexDirection="column" gap="m">
        <Flex flexDirection={['column', 'row']} gap={['m', 's']}>
          <KpiCard
            variant="usdc"
            title="USDC in PSM"
            data={data}
            field="reserve"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: tokensMapping('USDC'),
                  iconSize: '4'
                }
              }
            }}
          />
          <KpiCard
            title="DAI in PSM"
            variant="dai"
            data={data}
            field="dai"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: tokensMapping('DAI'),
                  iconSize: '4'
                }
              }
            }}
          />
        </Flex>
      </Flex>
    );
  }

  return <KpiSkeleton />;
}
